export const DEFAULT_ADMIN_TAB_ORDER = ['rifle', 'events', 'gallery', 'pages', 'quizzes', 'banner', 'about', 'leadership'] as const;
export type AdminTabId = typeof DEFAULT_ADMIN_TAB_ORDER[number];
export type AdminContentTab = Exclude<AdminTabId, 'rifle'>;
export const ADMIN_TAB_LABELS: Record<AdminTabId, string> = {
  rifle: 'Rifle scoring', events: 'Events', gallery: 'Gallery', pages: 'Pages',
  quizzes: 'Quiz Campaigns', banner: 'Banner', about: 'About us', leadership: 'Leadership',
};

export function validAdminTabOrder(value: unknown): value is AdminTabId[] {
  return Array.isArray(value) && value.length === DEFAULT_ADMIN_TAB_ORDER.length &&
    new Set(value).size === value.length &&
    value.every(id => DEFAULT_ADMIN_TAB_ORDER.includes(id));
}

export function readAdminTabOrder(value: unknown): AdminTabId[] {
  if (validAdminTabOrder(value)) return [...value];
  const legacy = DEFAULT_ADMIN_TAB_ORDER.filter(id => id !== 'leadership');
  if (Array.isArray(value) && value.length === legacy.length && new Set(value).size === value.length && value.every(id => legacy.includes(id))) return [...value, 'leadership'];
  return [...DEFAULT_ADMIN_TAB_ORDER];
}

export function moveAdminTab(order: readonly AdminTabId[], id: AdminTabId, direction: 'up' | 'down'): AdminTabId[] {
  const result = [...order];
  const index = result.indexOf(id);
  const next = index + (direction === 'up' ? -1 : 1);
  if (index >= 0 && next >= 0 && next < result.length) [result[index], result[next]] = [result[next], result[index]];
  return result;
}
